import React from 'react';
// @ts-expect-error - PNG import handled by webpack
import WellLogo from '../logos/well-logo.png';

const WellReportIllustration = (): React.ReactElement => (
    <div className="insight-main-tile__image-wrapper--margin-top">
        <img
            className="insight-main-tile__image-wrapper--flex-center"
            src={WellLogo}
            alt="International WELL Building Institute"
            width="190"
            height="124"
        />
    </div>
);

export default WellReportIllustration;
